import { useState } from 'react';
import constate from 'constate';

function useNotification() {
    const [notification, setNotification] = useState();
    const hasNotification = !!(notification?.text);

    return { notification, setNotification, hasNotification };
}

const [NotificationProvider, useNotificationContext] = constate(useNotification);

export {
    NotificationProvider,
    useNotificationContext
};
